import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_loan_andor_advance_money_to_wrkrs'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_loan_andor_advance_money_to_wrkrs',
  name: 'Does the facility loan and/or advance money to workers?',
  description:
    'The intent of this question is to understand if the facility ever loans and/or advances money to workers. \r\r\n\r\r\n"Loan" refers to an amount of money that is borrowed and has to be paid back, usually with interest.\r\r\n\r\r\nAn "advance" is an amount of money paid before it is due or for work only partly completed.\r\r\n\r\r\nIf the facility provides any type of loan or advance to worker, answer Yes.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-17',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 8750,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
